// NOVAPAY-116-RC3-R2 — route-level lazy legal bodies (keep initial chunk smaller).
import type { InfoSection } from "./store-info-v2.js";

export async function loadLegalSectionBody(
  kind: NonNullable<InfoSection["kind"]>,
  lang: "ua" | "en",
): Promise<string[] | null> {
  if (kind === "offer") {
    const mod = await import("./legal-content-offer-rc3-v2.js");
    return mod.buildPublicOfferBody(lang);
  }
  if (kind === "privacy") {
    const mod = await import("./legal-content-privacy-rc3-v2.js");
    return mod.buildPrivacyPolicyBody(lang);
  }
  return null;
}
